import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/harikaradmin/events-report")({
  head: () => ({ meta: [{ title: "Etkinlik Raporları — Admin" }] }),
  component: () => <Outlet />,
});
